import httpClient from 'shared/utils/http-client'
import 'modules/profile/account-settings/hooks/use-account-settings'
import { AccountSettingsInterface } from 'modules/profile/account-settings/types/account-settings-interface'

export const USER_ACCOUNT_SETTINGS_API = '/api/dashboard/settings/account'
export const USER_ACCOUNT_SETTINGS_FILTERS_API = '/api/dashboard/settings/account/filters'

export const updateUserAccountSettings = (data: AccountSettingsInterface) =>
  httpClient.put(USER_ACCOUNT_SETTINGS_API, data)

export const getUserAccountSettingsTimezones = () =>
  httpClient.get(USER_ACCOUNT_SETTINGS_FILTERS_API)
